import { formatDateTime } from "@/shared/utils/dateTimeHelpers";

import { RAIL_CURRENCY } from "../../constants/paymentRails.constants";
import type { RailAvailabilityCell, RailSettingState } from "../../types/paymentRails.types";

/** The row that decides the cell in the CURRENT scope (org view falls back to the global row). */
export function scopedState(cell: RailAvailabilityCell, scopeOrgId: string | null): RailSettingState | null {
  if (scopeOrgId) return cell.organization ?? cell.global;
  return cell.global;
}

/** True in org view when the organization holds its own row on this cell. */
export function hasOwnOverride(cell: RailAvailabilityCell, scopeOrgId: string | null): boolean {
  return scopeOrgId !== null && cell.organization !== null;
}

/** The currency left with every rail off once `cell` goes off too, or null while another of its rails runs. */
export function currencyLeftInMaintenance(
  cell: RailAvailabilityCell,
  cells: RailAvailabilityCell[],
): string | null {
  const currency = RAIL_CURRENCY[cell.rail];
  if (!currency) return null;
  const others = cells.filter(
    (other) =>
      RAIL_CURRENCY[other.rail] === currency &&
      !(other.rail === cell.rail && other.direction === cell.direction),
  );
  return others.every((other) => !other.effective_enabled) ? currency : null;
}

/** App-locale date, not the browser's — the page may render in another language than the OS. */
export function formatSince(since: string, locale: string): string {
  return formatDateTime(since, { locale, includeTime: false }) || since;
}
